import { useEffect } from 'react';
import axios from 'axios';
import useIp4 from '../hooks/useIp4';

const GEOLOCATION_API_URL = 'https://geolocation-db.com/json/';
const LOG_TAG = '[useClientIp]';

const useClientIp = () => {
    const { ip4, setIp4 } = useIp4();

    useEffect( () => {
        if ( ip4 ) return;

        const controller = new AbortController();

        const fetchClientIp = async () => {
            try {
                const response = await axios.get( GEOLOCATION_API_URL, {
                    signal: controller.signal,
                });

                if ( response?.data?.IPv4 ) {
                    setIp4( response.data.IPv4 );
                } else {
                    console.warn( `${LOG_TAG} No IPv4 found in response`, response.data );
                }
            } catch ( error ) {
                if ( axios.isCancel( error ) ) {
                    console.debug( `${LOG_TAG} Fetch aborted` );
                } else {
                    console.error( `${LOG_TAG} Failed to fetch IP:`, error.message );
                }
            }
        };

        fetchClientIp();

        return () => {
            controller.abort();
        };
    }, [ip4, setIp4] );
};

export default useClientIp;
